import ArrowRight from "@/assets/icons/ArrowRight";
import FlexPass from "@/assets/icons/FlexPass";
import AppButton from "@/components/shared/AppButton";
import { Card } from "@/components/shared/Card";
import { Box } from "@/components/ui/box";
import { HStack } from "@/components/ui/hstack";
import { Text } from "@/components/ui/text";
import { VStack } from "@/components/ui/vstack";
import { hashCode } from "@/utils/hashUtils";
import { T, useT } from "@transifex/react";
import { router } from "expo-router";

export interface ActiveFlexPassOption {
  name: string;
  usedPasses: number;
  maxPassUses: number;
  passNotes: string[];
  passID: string;
  canRedeemNow?: boolean;
}

export const ActiveFlexPassCard = ({ name, usedPasses, maxPassUses, passNotes, passID, canRedeemNow = true }: ActiveFlexPassOption) => {
  const t = useT();
  const handleUseFlexPass = () => {
    router.push({
      pathname: "/redeem/flex-park",
      params: { passID: passID },
    });
  };

  return (
    <Card className="pt-[20px] pb-[24px] px-[20px]">
      <VStack className="gap-[20px]">
        <HStack className="items-center gap-2">
          <FlexPass height="20" width="20" />
          <Text className="text-typography-900 text-[12px] font-[700] leading-[100%] tracking-[0.13em] relative top-0.5">
            <T _str="FLEX PARK" />
          </Text>
          <Text
            className={`text-typography-900 text-[12px] font-[700] leading-[100%] flex-1 text-right relative top-0.5 ${maxPassUses > usedPasses ? "" : "text-warning-700"}`}
          >
            {t("{left}/{max} Passes", { left: maxPassUses - usedPasses, max: maxPassUses })}
          </Text>
        </HStack>

        <Box>
          <Text className="text-[18px] font-bold leading-[100%] text-typography-900">{name}</Text>
        </Box>

        <VStack className="space-y-0">
          {passNotes.map((note) => (
            <HStack key={hashCode(note)} className="items-center">
              <Text className="mr-2 text-typography-900 font-semibold">•</Text>
              <Text className="text-typography-900 text-[14px] font-normal leading-[20px]">
                {" "}
                {note.replace("{uses}", (maxPassUses - usedPasses).toString())}
              </Text>
            </HStack>
          ))}
        </VStack>

        <AppButton
          title={canRedeemNow ? t("Use my FlexPark") : t("Not eligible for immediate use")}
          onPress={handleUseFlexPass}
          icon={canRedeemNow ? ArrowRight : undefined}
          iconPosition="after"
          disabled={!canRedeemNow}
        />
      </VStack>
    </Card>
  );
};
